(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxDimmedBgNested(
    $timeout, $filter, toastr, $http, $window
  ) {
    return {
      restrict: 'EA',
      scope: {
        mode: "=mode",
      },
      link: function(scope, element) {

        (function() {
          if (scope.mode === 'create') {
            placeInContextCenter();
          } else {
            placeInWindowCenter();
          }
        })();


        function placeInContextCenter () {
          $timeout(function() {
            const parent = angular.element('.context-content-container')[0] ?? angular.element('.context-content-container-alt')[0];
            element.css({
              width: parent.clientWidth + 2, 
              height: parent.clientHeight + 2,
              backgroundColor: 'black',
              opacity: 0.25,
              position: 'absolute',
              zIndex: 6,  
              top: '-1px',
              left: '-1px',
            })
          }, 40)
        }

        function placeInWindowCenter() {
          $timeout(function() {
            element.css({
              width: $window.innerWidth, 
              height: $window.innerHeight,
              backgroundColor: 'black',
              opacity: 0.25,
              position: 'absolute',
              zIndex: 6,  
              top: '0px',
              left: '0px',
            })
          }, 40)
        }

        function reportWindowSize() {
          if (scope.mode === 'create') {
            placeInContextCenter();
          } else {
            placeInWindowCenter();
          }
        }

        $window.addEventListener('resize', reportWindowSize);


        scope.$on('$destroy', function() {
          $window.removeEventListener('resize', reportWindowSize);
        });

      }
    };
  }

  pxDimmedBgNested.$inject = ['$timeout', '$filter', 'toastr', '$http', '$window'];

  angular
    .module('printix-admin')
    .directive('pxDimmedBgNested', pxDimmedBgNested);

})();
